<script>
  import axios from 'axios';
  import MagHistoryTile from './MagHistoryTile.vue';
  import MagHistoryTable from './MagHistoryTable.vue';

  export default {
    components: {
      MagHistoryTile,
      MagHistoryTable,
    },
    props: {
      type: [String, Number],
      id: [String, Number],
      table: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        items: [],
        loading: false,
      };
    },
    watch: {
      type() {
        this.init();
      },
      id() {
        this.init();
      },
    },
    methods: {
      async init() {
        this.loading = true;
        this.items = await this.get();
        this.loading = false;
      },
      get() {
        const self = this;
        return new Promise((resolve) => {
          if (!self.type || !self.id) {
            resolve([]);
            return;
          }
          axios
            .get(`/tourclient/api/history/${self.type}/${self.id}`)
            .then(({data}) => {
              resolve(data.Items);
            })
            .catch(() => {
              resolve([]);
            });
        });
      },
    },
    mounted() {
      this.init();
    },
  };
</script>
<template>
  <div
    v-loading="loading"
    class="mag-history"
  >
    <MagHistoryTable
      v-if="table"
      :items="items"
    />
    <MagHistoryTile
      v-else
      :items="items"
    />
  </div>
</template>
<style lang="scss">
  .mag-history {
    width: 100%;
  }

  .mag-history-tile {
    padding: 8px 16px;
    border-radius: 4px;
    background: #eee;
    font-size: 14px;

    &__title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
    }

    &__discription {
      margin-bottom: 8px;
    }

    &__action {
      font-weight: 700;
      font-size: 16px;
    }

    + .mag-history-tile {
      margin-top: 16px;
    }
  }

  .mag-history-table {
    font-size: 14px;
    height: 100%;
    overflow: auto;

    &__head {
      display: flex;
      font-weight: 700;
      border-bottom: 2px solid #2fb474;
      background: #ffffff;
      position: sticky;
      top: 0;
    }

    &__row {
      display: flex;
    }

    &__time {
      width: 130px;
      flex-shrink: 0;
      padding: 8px;
    }

    &__action {
      width: 100px;
      flex-shrink: 0;
      padding: 8px;
    }

    &__user {
      width: 150px;
      flex-shrink: 0;
      padding: 8px;
      text-overflow: ellipsis;
      word-break: normal;
      overflow: hidden;
    }

    &__discription {
      width: 100%;
      padding: 8px;
      text-overflow: ellipsis;
      word-break: normal;
      overflow: hidden;
    }

    &__body {
      .mag-history-table__row:nth-child(2n) {
        background: #ebeef5;
      }
    }
  }
</style>
